export default {
  BACKEUROP: 'rgba(168, 218, 220, 0.4)',
  BACKEUROPGLOBAL: 'rgba(168, 218, 220, 0.4)',
  BACKEUROPMEMBERS: 'rgba(168, 218, 220, 0.4)',
  LELIEVRE: 'rgba(168, 218, 220, 0.4)',
  MOULINSOUFFLET: 'rgba(69, 123, 157, 0.4)',
  HEDIS: 'rgba(29, 53, 87, 0.4)',
  ROCCAMAURA: '#d1dbde',
  ORAPI: 'rgba(132,215,239,0.68)',
  AGIDRA: 'rgba(136,239,132,0.68)',
};
